const paths = {
  settings: 'settings',
  home: '',
} as const;

const settingsPaths = {
  userManagement: `${paths.settings}/usermanagement`,
  workflows: `${paths.settings}/workflows`,
  virtualAgents: `${paths.settings}/virtualagents`,
} as const;

export default {
  ...paths,
  ...settingsPaths,
};
